import PageHeader from "../components/UI/PageHeader";

const TelegramInfoPage = ({ title, children }) => {
  return (
    <div className="w-full min-h-screen bg-gray-100">
      <PageHeader title={title} />
      <div className="w-full max-w-[600px] mx-auto [&>div]:justify-start [&>div>div]:my-0 [&>div>div]:rounded-none [&>div>div]:bg-transparent [&>div>div]:max-w-none [&>div>div]:p-4">
        {children}
      </div>
    </div>
  );
};

export default TelegramInfoPage;
